// FAQ content for each thematic page — SEO-optimized Q&A with Schema.org structured data.

export const faqMap = {
  'nutrition-hormonale': [
    {
      question: "Qu'est-ce que la nutrition hormonale et en quoi diffère-t-elle d'un régime classique ?",
      answer:
        "La nutrition hormonale ne se concentre pas sur les calories mais sur l'équilibre de vos hormones (insuline, cortisol, thyroïde, œstrogènes, progestérone). Le plan alimentaire est conçu pour rétablir cet équilibre, ce qui permet une perte de poids durable, une meilleure énergie et une diminution des symptômes liés aux déséquilibres hormonaux."
    },
    {
      question: "À qui s'adresse une consultation en nutrition hormonale ?",
      answer:
        "Particulièrement aux femmes qui présentent des troubles du cycle, un SOPK (syndrome des ovaires polykystiques), une résistance à l'insuline, des difficultés à perdre du poids malgré les efforts, des symptômes de préménopause ou ménopause, de la fatigue chronique, ou des fringales de sucre inexpliquées."
    },
    {
      question: "Combien de temps faut-il pour voir des résultats ?",
      answer:
        "Les premiers effets (énergie, digestion, sommeil) apparaissent généralement en 2 à 4 semaines. L'équilibre hormonal se rétablit progressivement sur 3 à 6 mois. Un cycle régulier ou une perte de poids durable nécessite souvent 6 à 12 mois d'accompagnement."
    },
    {
      question: "Est-ce que je dois faire des analyses sanguines avant la consultation ?",
      answer:
        "Ce n'est pas obligatoire pour la première consultation, mais elles sont très utiles. Si vous avez un bilan hormonal récent (TSH, cortisol, insuline, œstrogènes, progestérone), apportez-le. Sinon, nous pourrons vous orienter vers les examens pertinents."
    },
    {
      question: "Les consultations sont-elles remboursées par l'assurance ?",
      answer:
        "Les consultations de nutrition peuvent être prises en charge par certaines assurances complémentaires en Suisse (ASCA, RME). Vérifiez auprès de votre caisse. Nous vous fournissons les factures conformes."
    }
  ],

  'perte-poids-hormonale': [
    {
      question: "Pourquoi je n'arrive pas à perdre du poids malgré mes efforts ?",
      answer:
        "Dans 70% des cas, ce sont vos hormones qui bloquent la perte de poids : résistance à l'insuline, cortisol élevé, thyroïde ralentie, déséquilibre œstrogènes/progestérone. Tant que ces déséquilibres ne sont pas corrigés, manger moins ou faire plus de sport ne suffit pas."
    },
    {
      question: "Est-ce que je vais devoir faire un régime restrictif ?",
      answer:
        "Non, au contraire. Les régimes restrictifs aggravent les déséquilibres hormonaux (hausse du cortisol, ralentissement du métabolisme). Notre approche mise sur un rééquilibrage alimentaire durable, sans restriction excessive."
    },
    {
      question: "Combien de poids puis-je espérer perdre ?",
      answer:
        "Généralement 0,5 à 1 kg par semaine lorsque l'équilibre hormonal est restauré. L'objectif n'est pas une perte rapide mais une perte stable et durable, sans effet yo-yo."
    },
    {
      question: "Faut-il faire du sport en plus de la nutrition ?",
      answer:
        "Une activité physique douce (marche, yoga, musculation légère) est recommandée. En revanche, l'excès de cardio augmente le cortisol et peut bloquer la perte de poids. Nous adaptons les recommandations à votre profil hormonal."
    }
  ],

  'sopk-alimentation': [
    {
      question: "Le SOPK (syndrome des ovaires polykystiques) peut-il être traité uniquement par l'alimentation ?",
      answer:
        "L'alimentation est l'un des outils les plus puissants pour gérer le SOPK. 70% des femmes atteintes ont une résistance à l'insuline qui peut être largement améliorée par la nutrition. Dans la plupart des cas, une alimentation adaptée permet de retrouver un cycle régulier, réduire l'acné et la pilosité, et faciliter la perte de poids."
    },
    {
      question: "Quels sont les aliments à éviter absolument en cas de SOPK ?",
      answer:
        "Il n'existe pas de liste universelle. Selon votre profil SOPK (insulinorésistance, hyperandrogénie, inflammation, stress…), les ajustements ne sont pas les mêmes. C'est précisément pourquoi nous établissons d'abord un bilan complet avant toute recommandation."
    },
    {
      question: "Le SOPK cause-t-il de l'infertilité ?",
      answer:
        "Le SOPK peut compliquer la fertilité en raison de troubles de l'ovulation, mais une prise en charge nutritionnelle adaptée peut significativement améliorer la fertilité. Beaucoup de femmes retrouvent une ovulation régulière après 6-12 mois de suivi nutritionnel."
    },
    {
      question: "Les compléments alimentaires sont-ils utiles pour le SOPK ?",
      answer:
        "Certains compléments peuvent aider, mais leur efficacité dépend entièrement de votre profil hormonal et de vos éventuelles carences. Pris en libre-service, ils sont souvent inefficaces voire contre-productifs. Un accompagnement personnalisé permet de cibler ce qui est vraiment utile pour vous."
    }
  ],

  'premenopause-metabolisme': [
    {
      question: "Pourquoi je prends du poids en préménopause sans changer mes habitudes ?",
      answer:
        "La chute des œstrogènes et de la progestérone modifie la distribution des graisses (stockage abdominal), ralentit le métabolisme, favorise la résistance à l'insuline et provoque une perte de masse musculaire. Sans ajustement alimentaire, la prise de poids est presque inévitable."
    },
    {
      question: "À quel âge commence la préménopause ?",
      answer:
        "Généralement entre 40 et 50 ans, mais parfois dès 35 ans. Elle peut durer de 4 à 10 ans avant la ménopause (arrêt définitif des règles pendant 12 mois consécutifs)."
    },
    {
      question: "La nutrition peut-elle réduire les bouffées de chaleur ?",
      answer:
        "Oui, plusieurs leviers nutritionnels peuvent atténuer significativement les bouffées de chaleur — à condition qu'ils soient choisis en fonction de votre profil hormonal. C'est ce travail d'identification que nous menons en consultation."
    },
    {
      question: "Faut-il prendre un traitement hormonal ?",
      answer:
        "C'est une décision personnelle à discuter avec votre gynécologue. Beaucoup de femmes gèrent très bien les symptômes grâce à la nutrition et aux changements de mode de vie. Notre accompagnement est complémentaire à un éventuel traitement médical."
    }
  ],

  'sante-cardiovasculaire': [
    {
      question: "Pourquoi la santé cardiovasculaire des femmes est-elle spécifique ?",
      answer:
        "Les œstrogènes protègent le système cardiovasculaire avant la ménopause. Après la ménopause, le risque augmente significativement. Par ailleurs, les symptômes d'infarctus chez la femme sont souvent différents de ceux de l'homme et moins bien identifiés."
    },
    {
      question: "Quelle alimentation protège le cœur ?",
      answer:
        "Il n'existe pas une « bonne alimentation cardiovasculaire » applicable à toutes. Vos facteurs de risque (cholestérol, tension, glycémie, inflammation, hormones) déterminent les leviers nutritionnels les plus pertinents pour vous. Une approche personnalisée est bien plus efficace qu'un régime générique."
    },
    {
      question: "Le stress a-t-il un impact sur le cœur ?",
      answer:
        "Oui, le stress chronique augmente le cortisol, fait monter la tension artérielle et favorise l'inflammation. Il est un facteur de risque cardiovasculaire à part entière, souvent sous-estimé chez les femmes."
    },
    {
      question: "Quels examens cardiovasculaires sont recommandés ?",
      answer:
        "Selon l'âge et les antécédents : bilan lipidique, tension artérielle, échodoppler, ergométrie, Holter rythmique. Notre cardiologue Dr Hassanzadah réalise ces explorations sur place au centre."
    }
  ],

  'equilibre-emotionnel': [
    {
      question: "Qu'est-ce qu'un accompagnement corps-cœur ?",
      answer:
        "C'est une approche qui reconnaît le lien profond entre émotions, comportements alimentaires et équilibre hormonal. Elle combine nutrition, travail sur les émotions (notamment via l'hypnopraxie) et régulation du stress pour restaurer une harmonie globale."
    },
    {
      question: "Comment savoir si mes problèmes alimentaires sont liés aux émotions ?",
      answer:
        "Signes fréquents : vous mangez sans faim, en réponse au stress, à l'ennui ou à la tristesse. Vous ressentez de la culpabilité après manger. Vous avez des compulsions. Vous alternez restriction et excès. Dans ces cas, traiter la dimension émotionnelle est essentiel."
    },
    {
      question: "L'hypnopraxie est-elle une forme de psychothérapie ?",
      answer:
        "L'hypnopraxie est une méthode avancée de l'hypnose centrée sur l'éprouvé affectif. Elle ne remplace pas une psychothérapie classique mais s'inscrit dans une approche complémentaire de maturation émotionnelle corps-esprit."
    },
    {
      question: "Combien de séances sont nécessaires ?",
      answer:
        "Cela dépend de chaque personne et de la problématique. Certaines femmes ressentent des changements significatifs dès 3 à 5 séances, d'autres préfèrent un accompagnement plus long sur plusieurs mois."
    }
  ],

  'hypnose-perte-de-poids-vevey-clarens': [
    {
      question: "L'hypnose pour maigrir fonctionne-t-elle vraiment ?",
      answer:
        "L'hypnose ne fait pas maigrir par magie. Elle agit sur les mécanismes inconscients qui sabotent vos efforts : compulsions, grignotage émotionnel, stress, croyances limitantes. Combinée à une nutrition adaptée, elle peut considérablement augmenter vos chances de succès durable."
    },
    {
      question: "Est-ce que je vais perdre le contrôle pendant la séance ?",
      answer:
        "Non. L'hypnose est un état de conscience modifié dans lequel vous restez pleinement conscient(e). Vous pouvez sortir de l'état à tout moment. Vous ne ferez jamais rien contre votre volonté."
    },
    {
      question: "Combien de séances faut-il pour voir des résultats ?",
      answer:
        "Les premiers effets (réduction des compulsions, meilleure gestion du stress alimentaire) apparaissent souvent dès les 2-3 premières séances. Un accompagnement de 5 à 10 séances est généralement recommandé pour des résultats durables."
    },
    {
      question: "Les séances en ligne sont-elles aussi efficaces qu'en cabinet ?",
      answer:
        "Oui, les séances en visioconférence sont tout aussi efficaces. Elles offrent une grande flexibilité et permettent un accompagnement régulier sans contrainte de déplacement."
    }
  ],

  'hypnopraxie-vevey-montreux': [
    {
      question: "Quelle différence entre hypnose classique et Hypnopraxie® ?",
      answer:
        "L'hypnose classique travaille sur l'EMC (état modifié de conscience). L'Hypnopraxie® s'adresse davantage à l'EMA (état modifié d'affect) : elle travaille sur l'éprouvé émotionnel profond, le sentiment de soi et la maturation affective, pour une transformation plus intégrée corps-esprit."
    },
    {
      question: "Qui a créé l'Hypnopraxie® ?",
      answer:
        "L'Hypnopraxie® a été créée par le docteur Guy Chedeau et présentée pour la première fois en 2005 à Buenos Aires, au congrès mondial des psychothérapeutes."
    },
    {
      question: "Pour quelles problématiques l'Hypnopraxie® est-elle indiquée ?",
      answer:
        "Troubles alimentaires, compulsions, anxiété, stress chronique, somatisations (douleurs, troubles digestifs, fatigue), blessures émotionnelles, accompagnement de la perte de poids lorsque les émotions sont en jeu, et de la préménopause, SOPK (syndrome des ovaires polykystiques) et troubles hormonaux."
    },
    {
      question: "Une séance d'Hypnopraxie®, c'est comment concrètement ?",
      answer:
        "Une séance dure environ 1h. Elle comprend un temps d'échange pour comprendre ce que vous éprouvez, puis un travail en état modifié d'affect qui permet d'accompagner et d'intégrer l'éprouvé. Vous ressortez généralement avec une clarté émotionnelle nouvelle."
    }
  ],

  'nutritionniste-vevey-clarens': [
    {
      question: "Comment se déroule une première consultation en nutrition ?",
      answer:
        "La première consultation (environ 1h) comprend un échange approfondi sur vos antécédents, habitudes, objectifs et symptômes, suivi d'un bilan complet (éventuellement impédancemétrie). Vous repartez avec des pistes concrètes et un premier plan adapté."
    },
    {
      question: "Les consultations sont-elles remboursées par les assurances ?",
      answer:
        "Les nutritionnistes agréées ASCA et RME sont remboursées par de nombreuses assurances complémentaires suisses. Vérifiez auprès de votre caisse. Nous fournissons des factures conformes."
    },
    {
      question: "Où se trouvent les cabinets ?",
      answer:
        "Cabinet principal à Vevey (Av. du Général-Guisan 26) et consultations à Clarens (Montreux). Les deux sites sont facilement accessibles depuis toute la Riviera vaudoise."
    },
    {
      question: "Proposez-vous des consultations en ligne ?",
      answer:
        "Oui, les consultations en visioconférence sont disponibles pour plus de flexibilité, et sont particulièrement adaptées pour les consultations de suivi."
    }
  ],

  'perte-de-poids-vevey-clarens': [
    {
      question: "Combien coûte un accompagnement perte de poids ?",
      answer:
        "Le tarif varie selon le type de consultation (bilan initial, suivi, impédancemétrie). Une partie peut être prise en charge par votre assurance complémentaire. Contactez-nous pour un devis personnalisé."
    },
    {
      question: "Combien de temps dure un programme de perte de poids ?",
      answer:
        "Un programme durable nécessite généralement 3 à 6 mois de suivi pour la phase active, puis des consultations de stabilisation. L'objectif est une perte stable sans reprise."
    },
    {
      question: "Puis-je bénéficier d'un bilan impédancemétrique ?",
      answer:
        "Oui, le bilan impédancemétrique est inclus dans notre approche. Il permet de mesurer précisément la masse grasse, musculaire et hydrique, pour un suivi objectif de votre composition corporelle."
    },
    {
      question: "Est-ce que l'hypnose peut aider ma perte de poids ?",
      answer:
        "Oui, surtout en cas de compulsions, grignotage émotionnel ou relation conflictuelle avec la nourriture. L'hypnose (hypnopraxie) complète idéalement la nutrition pour des résultats durables."
    }
  ]
};

// FAQ — Page d'accueil
export const homeFaq = [
  {
    question: "Les consultations sont-elles remboursées par l'assurance ?",
    answer: "Oui. Le centre est agréé ASCA et RME : les consultations de nutrition et les séances d'hypnopraxie peuvent être prises en charge par la plupart des assurances complémentaires suisses, selon votre contrat. Vérifiez la couverture « médecines complémentaires » ou « thérapie nutritionnelle » auprès de votre assureur."
  },
  {
    question: "Combien coûte une consultation ?",
    answer: "La première consultation avec bilan complet est à 150 CHF, tout comme les prestations santé de la femme, l'hypnopraxie et l'analyse corporelle. Les consultations de suivi sont à 100 CHF. Ces montants peuvent être remboursés par votre assurance complémentaire (agréments ASCA et RME)."
  },
  {
    question: "Comment se déroule la première consultation ?",
    answer: "La première consultation (environ 1h00) comprend une anamnèse approfondie de votre histoire alimentaire, hormonale et émotionnelle, une analyse de composition corporelle par bio-impédancemétrie, puis la définition d'objectifs réalistes. Un plan alimentaire personnalisé est ensuite construit sur mesure."
  },
  {
    question: "Où se trouvent les cabinets ?",
    answer: "Le centre dispose de deux cabinets sur la Riviera vaudoise : à Vevey (Av. du Général-Guisan 26, 1800 Vevey) et à Clarens (Rue du Grammont 2, 1815 Clarens), à quelques minutes de Montreux et à moins de 20 minutes de Lausanne."
  },
  {
    question: "Comment prendre rendez-vous ?",
    answer: "Vous pouvez réserver en ligne en quelques clics via OneDoc ou nous appeler au 076 779 93 02."
  },
  {
    question: "Qu'est-ce que l'hypnopraxie ?",
    answer: "L'hypnopraxie est une méthode avancée de l'hypnose qui accède aux ressentis profonds pour apaiser, comprendre et favoriser un changement durable. Elle accompagne notamment le stress, les émotions, les compulsions alimentaires et la confiance en soi. Les séances peuvent être réalisées indépendamment d'un suivi nutritionnel."
  }
];

// FAQ — Page Cabinets
export const cabinetsFaq = [
  {
    question: "Comment accéder au cabinet de Vevey ?",
    answer: "Le cabinet de Vevey se situe à l'Av. du Général-Guisan 26, 1800 Vevey. Il est facilement accessible en transports publics comme en voiture, à quelques minutes du centre-ville et de la gare de Vevey."
  },
  {
    question: "Comment accéder au cabinet de Clarens ?",
    answer: "Le cabinet de Clarens se situe à la Rue du Grammont 2, 1815 Clarens, à quelques minutes du centre de Montreux. Il est accessible en bus, en train (gare de Clarens) ou en voiture."
  },
  {
    question: "Quels sont les horaires d'ouverture ?",
    answer: "Les consultations ont lieu du lundi au vendredi de 8h00 à 18h00 et le samedi de 9h00 à 13h00. Le centre est fermé le dimanche."
  },
  {
    question: "Faut-il une ordonnance médicale pour consulter ?",
    answer: "Non, aucune ordonnance n'est nécessaire pour prendre rendez-vous. Les consultations peuvent être remboursées par votre assurance complémentaire grâce aux agréments ASCA et RME, selon votre contrat."
  },
  {
    question: "Peut-on choisir son cabinet (Vevey ou Clarens) ?",
    answer: "Oui, vous choisissez librement le cabinet qui vous convient le mieux — Vevey ou Clarens — au moment de la prise de rendez-vous en ligne via OneDoc ou par téléphone au 076 779 93 02."
  }
];
